export default "__VITE_ASSET__052a8f26__"